import * as S from './styled'

import { useNavigate } from 'react-router-dom'

import { t } from 'i18next'

import iconsSprite from '@/assets/icons.svg'
import quickImg from '@/assets/image/quick-img.png'
import { useCommonState } from '@/core/context/useContext'

/**
 * 화면 우측 하단 플로팅 퀵 네비게이션
 * 스크롤 조건 없이 항상 표시
 */
export default function QuickNav() {
  const show = true
  const navigate = useNavigate()
  const { isLogin } = useCommonState()

  // 히스토리 플로팅 버튼 → 베팅 내역 페이지로 이동 (기존 모달 제거)
  const openHistory = () => {
    navigate('/bet-history')
  }

  const handleInstallClick = async () => {
    const prompt = window.deferredPrompt
    if (prompt) {
      prompt.prompt()
      window.deferredPrompt = null
    }
  }

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }

  return (
    <S.Root $show={show}>
      {isLogin && (
        <S.History>
          <S.HistoryLink onClick={openHistory}>
            <S.HistoryLabel>{t('footer.history')}</S.HistoryLabel>
            <img src={quickImg} alt={t('footer.history')} />
          </S.HistoryLink>
        </S.History>
      )}
      {window.deferredPrompt && (
        <S.App>
          <S.AppLink onClick={handleInstallClick}>
            <S.IconSpan $class="icon icon-color-b">
              <S.IconSvg $viewBox="0 0 28 28">
                <use href={`${iconsSprite}#ico-app`} />
              </S.IconSvg>
            </S.IconSpan>
          </S.AppLink>
        </S.App>
      )}
      <S.Top onClick={scrollToTop}>
        <S.TopIcon>
          <S.IconSpan $class="icon icon-color-w">
            <S.IconSvg $viewBox="0 0 24 24">
              <use href={`${iconsSprite}#ico-top`} />
            </S.IconSvg>
          </S.IconSpan>
        </S.TopIcon>
        <S.TopText>{t('footer.top')}</S.TopText>
      </S.Top>
    </S.Root>
  )
}
